import React from 'react';

import { StyleSheet } from 'react-native';

import { Box } from 'components/ui';
import type { BoxProps } from 'components/ui';
import { primitive } from 'styles/constants';

export const Separator = ({ style, ...props }: BoxProps) => (
  <Box {...props} style={[styles.separator, style]} />
);

const styles = StyleSheet.create({
  separator: {
    backgroundColor: primitive.$greyFour,
    height: 1,
  },
});
